var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ActionButton',{attrs:{"title":_vm.$t('general.catalog_pages'),"click-action":_vm.actionHandle}},[_c('b-icon-book-half')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }